import { render, staticRenderFns } from "./SingleReport.vue?vue&type=template&id=5b081aaa&scoped=true&lang=pug&"
import script from "./SingleReport.vue?vue&type=script&lang=ts&"
export * from "./SingleReport.vue?vue&type=script&lang=ts&"
import style0 from "./SingleReport.vue?vue&type=style&index=0&id=5b081aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b081aaa",
  null
  
)

export default component.exports